export const SUCCESS_RESPONSE = 200;

export const BAD_REQUEST = 400;
export const UN_AUTHOR_RESPONSE = 401;
export const NOT_FOUND_RESPONSE = 404;

export const SERVER_ERROR_RESPONSE = 500;
